import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '@constants/colors';
import { withStyles } from 'tss-react/mui';
import { Badge, Icon } from '@mui';

const StyledBadge = withStyles(Badge, {
  // Override styles applied to the root element
  // if `anchorOrigin={{ 'bottom', 'right' }} overlap="circular"`. */
  anchorOriginBottomRightCircular: {
    bottom: '24%',
    right: '24%',
    transform: 'scale(1) translate(50%, 50%)',
    transformOrigin: '100% 100%',
    '&$invisible': {
      transform: 'scale(0) translate(50%, 50%)'
    }
  }
});

const BadgeIcon = ({ children, label = 'Restricted', size }) => (
  <StyledBadge
    overlap="circular"
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    badgeContent={
      // The "block" ligature text isn't a real accessible name on its own - this badge is
      // the only indicator of its meaning (e.g. inactive user, excluded date), so it needs a
      // real aria-label rather than being hidden.
      <Icon role="img" aria-label={label} color={colors.brand.red} style={{ fontSize: size }}>block</Icon>
    }
  >
    {children}
  </StyledBadge>
);

BadgeIcon.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  size: PropTypes.number
};

export default BadgeIcon;
